import { BottomSheetDialog } from '@/components/Modal/Dialog/BottomSheetDialog';

import { useFormContext } from '@/hooks/useFormContext';
import { useTranslate } from '@/hooks/useTranslate';

import { MinorConsentFormData } from '../MinorQuestionConsentSign';
import ConfirmChoiceAlert from './ConfirmChoiceAlert';

interface ConfirmConsentModalProps {
  onClose: () => void;
  onConfirm: (formData: MinorConsentFormData) => void;
  isOpen: boolean;
  isPending: boolean;
}
export const ConfirmConsentModal = ({
  onClose,
  isOpen,
  onConfirm: updateConsent,
  isPending,
}: ConfirmConsentModalProps) => {
  const { t } = useTranslate();
  const { getValues } = useFormContext<MinorConsentFormData>();

  if (!isOpen) return null;

  const onConfirm = () => {
    const formData = getValues();
    updateConsent(formData);
  };

  return (
    <BottomSheetDialog
      modalProps={{ size: 'lg' }}
      onClose={onClose}
      title={t('questionDrawer.minorQuestionConsentSign.dialog.title')}
      description={t(
        'questionDrawer.minorQuestionConsentSign.dialog.description',
      )}
      primaryText={t(
        'questionDrawer.minorQuestionConsentSign.dialog.primaryText',
      )}
      secondaryText={t(
        'questionDrawer.minorQuestionConsentSign.dialog.secondaryText',
      )}
      indicator={{ type: 'primaryWarning', icon: 'check-circle' }}
      content={<ConfirmChoiceAlert />}
      primaryAction={onConfirm}
      primaryActionProps={{ disabled: isPending }}
      secondaryAction={onClose}
      secondaryActionProps={{ disabled: isPending }}
    />
  );
};
